import { useId } from '@atlaskit/ds-lib/use-id';
export var PREFIX = 'ds--dropdown--';

/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */
export default function useGeneratedId() {
  var id = useId();
  return "".concat(PREFIX).concat(id);
}